import { render, staticRenderFns } from "./RgpCompanies.vue?vue&type=template&id=1e896f16&scoped=true&"
import script from "./RgpCompanies.vue?vue&type=script&lang=js&"
export * from "./RgpCompanies.vue?vue&type=script&lang=js&"
import style0 from "./RgpCompanies.vue?vue&type=style&index=0&id=1e896f16&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e896f16",
  null
  
)

export default component.exports